import React from 'react'
import { Modal, Button, Radio } from 'util/ui'
import { v4 as uuidV4 } from 'uuid'
import { isFunction } from 'util/functions'
import styles from '../../styles.less'

export default class RadioQuestionStep extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      answer: null,
    }
    this.componentId = uuidV4()
  }

  handleAnswerChange = (evt, { label }) => {
    this.setState({
      answer: label,
    })
  }

  handleNext = () => {
    const { onNext, question } = this.props
    const { answer } = this.state
    if (isFunction(onNext))
      onNext({
        question,
        answer,
      })
  }

  render() {
    const { onCancel, question, answers, open } = this.props
    const { answer } = this.state

    return (
      <Modal open={open} className={styles.billingModal}>
        <Modal.Header>Cancel account</Modal.Header>
        <Modal.Content>
          <div>
            {question.split('\n').map((item, index) => {
              const key = `${this.componentId}-${index}`
              return (
                <p key={key}>
                  {item}
                  <br />
                </p>
              )
            })}
            <p>
              {answers.map((a, i) => (
                <Radio
                  // eslint-disable-next-line react/no-array-index-key
                  key={`billing-cancellation-step-${this.componentId}-${i}`}
                  label={a}
                  name={`billing-cancellation-step-${this.componentId}-${i}`}
                  onChange={this.handleAnswerChange}
                  checked={answer === a}
                />
              ))}
            </p>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button positive onClick={onCancel}>
            Nevermind, I don{"'"}t want to cancel
          </Button>
          <Button disabled={answer === null} onClick={this.handleNext}>
            Next step
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}
